import React, { useCallback, useEffect, useRef, useState } from "react";
import SubNav from "../../../Shared/SubNav";
import { useNavigate } from "react-router-dom";
import socket from "../../../context/socket";
import { debounce } from "lodash";
import axios from "axios";
import { Form, Button, Row, Col, InputGroup, Alert, Spinner } from "react-bootstrap";
import CaptchaVerification from "../../Modals/CaptchaVerification";
import CaptchaVerificationV2 from "../../Modals/CaptchaVerificationV2";
import { decodeId } from "../../../Shared/urlEncode";
import VerifyModal from "./modals/VerifyModal";
import AppointmentScheduleModal from "./modals/AppointmentScheduleModal";
import { useDispatch, useSelector } from "react-redux";
import { fetchClientData } from "../../../redux/client/clientSlice";
import toast, { Toaster } from "react-hot-toast";
import Select from "react-select";
import { Controller } from "react-hook-form";

import api from "../../../utils/api";

export const NeedFromYou = ({ isDarkMode }) => {
  const roomId = new URLSearchParams(window.location.search).get("clientId");
  // const isDarkMode = false;

  const [countryOptions, setCountryOptions] = useState([]);

  const [hasTin, setHasTin] = useState(""); // yes | no
  const [tinNumber, setTinNumber] = useState("");
  const [idType, setIdType] = useState("");
  const [tinError, setTinError] = useState("");
  const [isCity, setIsCity] = useState("");
  const [isCountry, setIsCountry] = useState("");
  console.log('isCountry', isCountry);

  const [cityError, setCityError] = useState("");
  const [countryError, setCountryError] = useState("");
  const tinSavedRef = useRef(false);





  const [modalShowVerify, setModalShowVerify] = useState(false);
  const [showModal, setShowModal] = useState(false);


  const dispatch = useDispatch();

  const navigate = useNavigate();
  const [panNumber, setPanNumber] = useState("");
  const [panError, setPanError] = useState("");
  const [panErr, setPanErr] = useState(false);
  const [kycStatus, setKycStatus] = useState(null);
  const [showWebcamMic, setShowWebcamMic] = useState(false);
  const [isKycDone, setIsKycDone] = useState('no');
  const [fatcaStatus, setFatcaStatus] = useState("no");
  const [fatcaError, setFatcaError] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [aadhaarConfirmed, setAadhaarConfirmed] = useState(false);
  const [iAmOption, setIAmOption] = useState("");
  const [iAmError, setIAmError] = useState("");
  const [clientEmail, setClientEmail] = useState("");
  const [isRelation, setRelation] = useState("");
  const [relationError, setRelationError] = useState("");
  const [isRelation2, setRelation2] = useState("");
  const [isEmail, setIsEmail] = useState("");
  const [isMobile, setIsMobile] = useState("");
  const [relation2Error, setRelation2Error] = useState("");
  const [isMobileError, setIsMobileError] = useState("");
  const [isEmailError, setIsEmailError] = useState("");

  const [isConfirm, setIsConfirm] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [panstatusmsg, setPanstatusmsg] =
    useState();
  // "Click on button to check status "
  const [isFetching, setIsFetching] = useState("");
  // console.log("panstatusmsg", panstatusmsg);

  const { clientData } = useSelector((state) => state.client);

  // client data
  useEffect(() => {

    try {


      setIAmOption(clientData.kyc_info?.identity);
      setPanNumber(clientData?.kyc_info?.pan_no);
      setRelation(clientData?.mob_declaration || 'SE');
      setRelation2(clientData?.email_declaration || 'SE');
      const clientAddressProof =
        (clientData.kyc_doc &&
          clientData.kyc_doc.filter(
            (item) => item.doctype === "contact_details"
          )) ||
        [];
      console.log("response:", clientData);
      // setIsPan(clientData.kyc_info[0].pan_no)
      // setClientData(clientData);
      // setPanNumber(clientData.kyc_info[0].pan_no)
      const data = clientAddressProof[0];
      const kycDetails = data.data[0];
      // console.log("kycDetails", kycDetails);

      // console.log("llllll");
      setIsEmail(kycDetails.kycemail);
      setIsMobile(kycDetails.mobile || kycDetails.mobile_no);
      // })
      // .catch((error) => {
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    // });
  }, [clientData, setIAmOption, setPanNumber, setIsMobile]);



  useEffect(() => {
    const kyc = clientData?.kyc_info;
    if (!kyc) return;

    // ---- HAS TIN ----
    if (kyc.has_tin_number) {
      setHasTin(kyc.has_tin_number);
    }

    // ---- TIN NUMBER ----
    if (kyc.tin_number) {
      setTinNumber(kyc.tin_number);
      setHasTin("yes");
    }

    // ---- TIN TYPE (when no TIN) ----
    if (kyc.tin_type) {
      setIdType(kyc.tin_type);
      setHasTin("no");
    }

    // ---- CITY ----
    if (clientData?.city) {
      setIsCity(clientData?.city);
    }

    // ---- COUNTRY (react-select) ----
    if (clientData?.nri_country && countryOptions.length > 0) {
      const matchedCountry = countryOptions.find(
        (c) =>
          c.label === clientData?.nri_country ||
          c.value === clientData?.nri_country
      );
      if (matchedCountry) {
        setIsCountry(matchedCountry);
      }
    }

  }, [clientData, countryOptions]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const res = await api.get("advisor/fetch/country");
        const formatted = (res.data?.data || []).map((c) => ({
          label: c.country_name,
          value: c.country_name,
        }));

        setCountryOptions(formatted);
      } catch (error) {
        console.error("Failed to fetch countries", error);
      }
    };

    fetchCountries();
  }, []);




  useEffect(() => {
    socket.emit("join", roomId);
  }, [roomId]);

  // Debounced function to emit data
  const sendDataToServer = useCallback(
    debounce((data) => {
      socket.emit("message", { room: roomId, data });
      // console.log("emited data", data);
    }, 500),

    [roomId]
  );

  useEffect(() => {
    sendDataToServer({
      panNumber,
      kycStatus,
      isEmail,
      panstatusmsg,
      isMobile,
      aadhaarConfirmed,
      iAmOption,
      clientEmail,
      isRelation,
      isRelation2,
    });
  }, [
    sendDataToServer,
    panNumber,
    panstatusmsg,
    kycStatus,
    aadhaarConfirmed,
    iAmOption,
    isRelation,
    isRelation2,
    isEmail,
    isMobile,
    clientEmail,
  ]);

  // recive data  io server
  useEffect(() => {
    socket.emit("join", { room: roomId });
    socket.on("message_to", (msg) => {
      console.log("Message resived from client:", msg);
      setFatcaStatus(msg.data.fatcaStatus);
    });
  }, []);

  useEffect(() => {
    saveKYCClientIdentity();

  }, [iAmOption, panError, roomId, panNumber, panErr]);

  const saveKYCClientIdentity = async () => {
    if (iAmOption) {
      if (!panErr) {
        const allData = {
          _id: roomId,
          pan_no: panNumber,
          client_identity: iAmOption,
        };

        try {
          const response = await api.post(
            `advisor/save_kyc_client_identity`,
            allData
          );
          // console.log("KYC data saved successfully", response.data);
          dispatch(fetchClientData(roomId));

        } catch (error) {
          console.error("Error saving KYC data", error);
        }
      }
    } else {
      console.error("Error: Some required fields are empty or invalid.");
    }
  };

  console.log("isMobile", isMobileError, isEmailError);

  const saveContactIdentity = async (relation) => {
    if (!isMobileError && !isEmailError) {
      const allData = {
        _id: roomId,
        mob_declaration: isRelation,
        email_declaration: isRelation2,
        email: isEmail,
        mobile: isMobile,
      };
      console.log("allData", allData);

      if (allData.email === "" && allData.mobile === "") {
        return;
      }
      try {
        const response = await api.post(
          `advisor/add_kyc_contact_details`,
          allData
        );
        console.log("saveContactIdentity saved successfully", response.data);
      } catch (error) {
        console.error("Error saving KYC data", error);
      }
    }
  };

  const handleMobileChange = (e) => {
    const input = e.target.value;
    if (/^\d{0,10}$/.test(input)) {
      setIsMobile(input);
      setIsMobileError(input.length !== 10);
    }
  };

  const handleEmailChange = (e) => {
    const email = e.target.value.trim();
    setIsEmail(email);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;


    if (!email) {
      setRelation2Error("Email is required.");
      setIsEmailError(true);
    } else if (!emailRegex.test(email)) {
      setRelation2Error("Please enter a valid email address.");
      setIsEmailError(true);
    } else {
      setRelation2Error("");
      setIsEmailError(false);
    }
  };


  useEffect(() => {
    if (!isMobileError && !isEmailError) {
      saveContactIdentity();
    }
  }, [isMobileError, isEmailError, isRelation, isRelation2]);

  const handleRelationChange = (e) => {
    setRelation(e.target.value);
    setRelationError("");
  };

  const handleRelation2Change = (e) => {
    setRelation2(e.target.value);
    const relation = e.target.value
    console.log('gg', relation);

    setRelation2Error("");
  };

  const handleNext = async () => {


    let hasError = false;

    // Validate iAmOption
    if (!iAmOption) {
      setIAmError("This field is required");
      hasError = true;
    } else {
      setIAmError(""); // Clear error
    }

    // Validate isRelation
    if (!isRelation) {
      setRelationError("This field is required");
      hasError = true;
    } else {
      setRelationError(""); // Clear error
    }

    // Validate isMobile (10 digits only)
    const mobileRegex = /^\d{10}$/;
    if (!isMobile) {
      setIsMobileError("Mobile number is required");
      hasError = true;
    } else if (!mobileRegex.test(isMobile)) {
      setIsMobileError("Mobile number must be exactly 10 digits");
      hasError = true;
    } else {
      setIsMobileError("");
    }

    // Validate isEmail (basic email format check)
    const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    if (!isEmail) {
      setIsEmailError("Email is required");
      hasError = true;
    } else if (!emailRegex.test(isEmail)) {
      setIsEmailError("Please enter a valid email address");
      hasError = true;
    } else {
      setIsEmailError("");
    }

    // Validate isRelation2
    if (!isRelation2) {
      setRelation2Error("This field is required");
      hasError = true;
    } else {
      setRelation2Error(""); // Clear error
    }

    // Validate FATCA status if panstatusmsg is "KYC not Done."
    if (panstatusmsg === "KYC not Done.") {
      if (!fatcaStatus) {
        setFatcaError("Please select FATCA status");
        hasError = true;
      } else {
        setFatcaError(""); // Clear error
      }
    }

    if (iAmOption === "21" || iAmOption === "24") {
      if (hasTin === "yes") {
        if (!tinNumber || tinNumber.length >= 15) {
          setTinError("Please enter a valid  TIN number");
          hasError = true;
        }
      }

      if (hasTin === "no") {
        if (!idType) {
          setTinError("Please select an ID type");
          hasError = true;
        }
      }
      await saveTinDetails();
    }




    if (!hasError) {
      const nextUrl = `/address-proof?clientId=${roomId}`;

      if (showWebcamMic) {
        if (isConfirm) {
          socket.emit("navigate", { room: roomId, url: nextUrl });
          navigate(nextUrl);
        } else {
          toast('⚠️ Please confirm before proceeding.');


        }
        //  If showWebcamMic is true but not confirmed, do nothing
        return;
      } else {
        if (!isFetching) {
          socket.emit("navigate", { room: roomId, url: nextUrl });
          navigate(nextUrl);
        }
      }

      // console.log('gb',showWebcamMic && isConfirm);



    }

  };

  const handleBack = () => {
    // const prevUrl = `/address-proof?clientId=${roomId}`;
    const prevUrl = `/goal-tracker?clientId=${roomId}`;

    socket.emit("navigate", { room: roomId, url: prevUrl });
    navigate(prevUrl);
  };

  const validatePanNumber = (pan) => {
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    return panRegex.test(pan);
  };

  const handlePanChange = (e) => {
    const value = e.target.value.toUpperCase();
    let error = validatePanNumber(value) ? "" : "Invalid PAN number";
    setPanNumber(value);
    setPanError(validatePanNumber(value) ? "" : "Invalid PAN number");
    setPanErr(error === "Invalid PAN number" ? true : false);
  };



  useEffect(() => {
    console.log('panNumber', panNumber, clientData?.kyc_info?.is_kyc_done);

    if (panNumber !== undefined) {
      handleGetKYCStatus();
    }
  }, [clientData, panNumber]);


  const handleGetKYCStatus = async () => {

    // console.log('panNumber',panNumber);

    if (!validatePanNumber(panNumber)) {
      setPanError("Please enter a valid PAN number");
      return;
    }

    const postData = {
      _id: roomId,
      pannumber: panNumber,
    };

    try {
      setIsFetching(true); // Start loading
      setPanError(""); // Clear errors

      const response = await api.post(
        `advisor/cams_get_pan_status`,
        postData
      );

      const data = response.data;

      setPanstatusmsg(data.kyc_message || "Status not available");
      setIsKycDone(data.is_kyc_done);

      const panstatus = data.APP_STATUS;
      const panupdtstatus = data.APP_UPDT_STATUS;

      const panstatuscode = String(panstatus).slice(-2);
      var panupdtstatuscode = String(panupdtstatus).slice(-2);
      var panupdtstatuscode = panupdtstatuscode.replace(/\s+/g, "");
      console.log("panstatuscode", panstatuscode, panupdtstatuscode, data);
      setKycStatus(panstatuscode);

      // Define conditions based on status codes
      //   if (panupdtstatuscode === "00" || panstatuscode === "00") {
      //     setPanstatusmsg("Not Checked with respective KRA");
      //   } else if (panupdtstatuscode == "01" || panstatuscode == "01") {
      //     setPanstatusmsg("KYC is Under Process");
      //   } else if (
      //     (panupdtstatuscode == "02" && panstatuscode == "02") ||
      //     (panupdtstatuscode == "01" && panstatuscode == "05") ||
      //     (panupdtstatuscode == "05" && panstatuscode == "01") ||
      //     (panstatuscode == "02" && panupdtstatuscode == "05") ||
      //     (panstatuscode == "02" && panupdtstatuscode == "") ||
      //     (panstatuscode == "02" && panupdtstatuscode == "01")
      //   ) {
      //     setPanstatusmsg("KYC Registered.");
      //   } else if (
      //     (panstatuscode == "07" && panupdtstatuscode == "01") ||
      //     (panstatuscode == "07" && panupdtstatuscode == "02") ||
      //     (panstatuscode == "07" && panupdtstatuscode == "05") ||
      //     (panstatuscode == "07" && panupdtstatuscode == "07") ||
      //     (panstatuscode == "07" && panupdtstatuscode == "") ||
      //     (panstatuscode == "07" && panupdtstatuscode == "04") ||
      //     panstatuscode == "07"
      //   ) {
      //     setShowWebcamMic(false);
      //     setPanstatusmsg("KYC Validated.");
      //   } else if (
      //     panupdtstatuscode == "03" ||
      //     panstatuscode == "03" ||
      //     panstatuscode == "11" ||
      //     panstatuscode == "12" ||
      //     panstatuscode == "13" ||
      //     panstatuscode == "14" ||
      //     panstatuscode == "22"
      //   ) {
      //     setPanstatusmsg("KYC Modification is Required.");
      //   } else if (
      //     (panupdtstatuscode == "01" && panstatuscode == "02") ||
      //     (panupdtstatuscode == "01" && panstatuscode == "22")
      //   ) {
      //     setPanstatusmsg("KYC Modification is Under Process.");
      //   } else if (panstatuscode == "05") {
      //     setShowWebcamMic(true);
      //     setPanstatusmsg("KYC not Done.");
      //   } else if (panstatuscode == "99") {
      //     setPanstatusmsg("Invalid Pan");
      //   } else if (panstatuscode == "88") {
      //     setPanstatusmsg(
      //       "Could not check KYC status with one or more agencies. Please try after some time."
      //     );
      //   } else {
      //     setPanstatusmsg("Unknown status. ");
      //   }

      //   // if (["02", "03"].includes(panstatuscode)) {
      //   //   setShowWebcamMic(false);
      //   // } else {
      //   //   setShowWebcamMic(true);
      //   // }
    } catch (error) {
      console.error("Error fetching KYC status:", error);
      setPanError("Failed to fetch KYC status.");
    } finally {
      setIsFetching(false);
    }
  };

  const handleSave = (data) => {
    // console.log("data", data);
  };

  const handleVerifyModal = () => {
    // setModalShowVerify(true)
    window.open('https://myaadhaar.uidai.gov.in/verify-email-mobile', '_blank');

  }
  const handleSchedule = () => {
    setShowModal(true)
  }
  const handleConfirm = (e) => {
    // console.log('dd',e.target.checked );
    setIsConfirm(e.target.checked)
  }

  useEffect(() => {
    if (iAmOption !== "21" && iAmOption !== "24") {
      setHasTin("");
      setTinNumber("");
      setIdType("");
      setTinError("");
    }
  }, [iAmOption]);

  const handleBlurSave = () => {
    // if (tinResolved) return;
    saveTinDetails();
  };



  const handleTinBlur = () => {
    if (tinSavedRef.current) return;
    saveTinDetails();
  };


  const validateTinBeforeSave = () => {
    if (!hasTin) return false;

    if (!isCity.trim()) {
      setCityError("City is required");
      return false;
    }

    if (!isCountry) {
      setCountryError("Country is required");
      return false;
    }

    if (hasTin === "yes") {
      if (!/^[A-Z0-9-]{8,15}$/.test(tinNumber)) {
        setTinError("TIN must be 8–15 characters");
        return false;
      }
    }

    if (hasTin === "no" && !idType) {
      setTinError("Please select ID type");
      return false;
    }

    return true;
  };


  const saveTinDetails = async () => {
    if (iAmOption !== "21" && iAmOption !== "24") return;
    if (!validateTinBeforeSave()) return;

    const payload = {
      client_id: roomId,
      has_tin_number: hasTin,
      tin_number: hasTin === "yes" ? tinNumber : "",
      tin_type: hasTin === "no" ? idType : "",
      city: isCity,
      country: isCountry.label,
    };

    try {
      await api.post("advisor/save_tin_details", payload);
      tinSavedRef.current = true;
      console.log("TIN details saved");
    } catch (error) {
      console.error("Error saving TIN details", error);
    }
  };

  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />

      <div className="container minht">
        <div className="flex flex-col md:flex-row items-start md:px-8">
          <div className="w-full">
            <h2 className="text-lg md:text-xl lg:text-2xl font-semibold">
              What we‘ll need from you
            </h2>
          </div>
        </div>

        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center my-5 gap-4">
          {/* Section 1: I am Select Input */}
          <div className="d-flex flex-nowrap align-items-center w-100 w-md-50 gap-2">
            <p className="reward24 m-0 flex-shrink-0">I am</p>
            <div className="flex-grow-1">
              <select
                value={iAmOption}
                className="form-select border-0  rounded-0 border-bottom border-success px-3 py-1 w-100 pe-5"
                style={{ minWidth: "7ch", maxWidth: "200px" }} // Prevents full width on large screens
                onChange={(e) => {
                  setIAmOption(e.target.value);
                  setIAmError("");
                }}
              >
                <option value="" defaultValue>
                  Select
                </option>
                <option value="01">a Resident Individual</option>
                <option value="02">a Minor</option>
                <option value="21">an NRI (with an NRE Account)</option>
                <option value="24">an NRI (with an NRO Account)</option>
                <option value="03">HUF</option>

              </select>
              {iAmError && <div className="text-danger">{iAmError}</div>}
            </div>
          </div>

          {/* Section 2: PAN Number Input */}
          <div className="d-flex align-items-center flex-nowrap w-100 w-md-50 gap-2 ">
            <p className="reward24 m-0 flex-shrink-0 me-md-3">
              My PAN number is
            </p>
            <div className="flex-grow-1">
              <input
                type="text"
                className={`refer fw-bold form-control rounded-0 border-0 border-bottom border-success px-3 py-1 verify3 ${panError ? "is-invalid" : ""
                  }`}
                value={panNumber}
                onChange={handlePanChange}
                placeholder="PAN Number"
                style={{ minWidth: "150px", maxWidth: "250px", width: "100%" }} // Keeps it responsive
              />
              {panError && (
                <div className="invalid-feedback text-center">{panError}</div>
              )}
            </div>
          </div>

          {/* Section 3: Get KYC Button */}
          <div className="d-flex align-items-center flex-nowrap justify-content-between w-100">
            <p className="m-0 me-auto">{panstatusmsg}</p>{" "}
            {/* Pushes button to the right */}
            <button
              type="button"
              className="clrgreen bg-transparent rounded-pill border px-3 py-1"
              onClick={handleGetKYCStatus}
              disabled={isFetching}
              style={{ whiteSpace: "nowrap" }} // Prevents button from wrapping
            >
              {isFetching ? "Fetching..." : "Get KYC Status"}
            </button>
          </div>
        </div>

        {/* d-none d-md-block */}

        <div className="row row-cols-1 row-cols-md-2 row-cols-xl-6 g-3 text-center d-flex justify-content-between">
          <div className="col">
            <div className="border border-1 py-3 mobheight brdr d-flex flex-column align-items-center justify-content-center h-100">
              <p className="reward24">Address Proof</p>
              <img src="assets/images/passport-and-tickets.png" alt="" className="img-fluid my-3" />
              <p className="fs-14 fw-normal clrdark mt-2">A clear copy of your <br /> Address proof</p>
            </div>
          </div>

          <div className="col">
            <div className="border border-1 py-3 mobheight brdr d-flex flex-column align-items-center justify-content-center h-100">
              <p className="reward24">Identity Proof</p>
              <img src="assets/images/pan-card.svg" alt="" className="img-fluid my-3" />
              <p className="fs-14 fw-normal clrdark mt-2">A clear copy of your <br /> PAN card</p>
            </div>
          </div>

          <div className="col">
            <div className="border border-1 py-3 mobheight brdr d-flex flex-column align-items-center justify-content-center h-100">
              <p className="reward24">
                Cancelled <br />
                Cheque
              </p>
              <img src="assets/images/receipt.svg" alt="" className="img-fluid my-3" />
              <p className="fs-14 fw-normal clrdark mt-2">With your name on it</p>
            </div>
          </div>

          <div className="col">
            <div className="border border-1 py-3 mobheight brdr d-flex flex-column align-items-center justify-content-center h-100">
              <p className="reward24">Signature</p>
              <img src="assets/images/signature.png" alt="" className="img-fluid my-3" style={{ maxHeight: '150px', width: '50%' }} />
              <p className="fs-14 fw-normal clrdark mt-2">On plain white paper</p>
            </div>
          </div>

          {(!clientData?.kyc_info?.is_kyc_done === 'yes' ||
            isKycDone !== 'yes'
            // || showWebcamMic
          ) && (
              <div className="col">
                <div className="border border-1 py-3 mobheight brdr d-flex flex-column align-items-center justify-content-center h-100">
                  <p className="reward24">Webcam & MIC</p>
                  <img
                    src="assets/images/webcam.svg"
                    alt=""
                    className="img-fluid mt-3"
                    style={{ maxHeight: '100px', width: '50%' }}
                  />
                  <p className="fs-14 fw-normal clrdark mt-2">A clear copy of your Image<br />Passport Photo</p>
                </div>
              </div>
            )}
        </div>


        {panstatusmsg == "KYC not Done." && (
          <div className="row mt-4">
            <div className="col">
              <div className="d-flex gap-4 ">
                <p className="reward24">
                  Do you pay tax outside India (FATCA)?{" "}
                </p>
                <div className="d-flex">
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="fatca"
                      id="fatcaYes"
                      value="yes"
                      checked={fatcaStatus === "yes"}
                      readOnly
                    />
                    <label className="form-check-label fs-5" htmlFor="fatcaYes">
                      <p className="d-inline">Yes</p>
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="fatca"
                      id="fatcaNo"
                      value="no"
                      checked={fatcaStatus === "no"}
                      readOnly
                    />
                    <label className="form-check-label fs-5" htmlFor="fatcaNo">
                      <p className="d-inline">No</p>
                    </label>
                  </div>
                </div>
              </div>
              {fatcaError && <p className="text-danger mt-2">{fatcaError}</p>}
            </div>
          </div>
        )}

        <div className="row mt-3">
          <div className="col-lg-12 d-flex gap-2 align-items-center">

            <span className="reward24 text-dark me-2">Don’t have the documents ready?</span>
            <button type="button" className="clrgreen ms-md-3 mt-3 mt-md-0 bg-transparent rounded-pill border p-2 d-flex gap-2 align-items-center"
              onClick={handleSchedule}>
              <img src="assets/images/time.svg" alt="" className="darkmodechnge" />
              Schedule the time
            </button>
          </div>
        </div>
        <div className="row mt-4  md:p-0">
          <div className="col-12 col-md d-flex flex-column flex-md-row gap-2 align-items-start">
            <p className="reward24 mb-2 mb-md-0">
              Please confirm your registered mobile number:
            </p>

            <input
              type="tel"
              placeholder="Mobile number"
              className="my-2 my-md-0 rounded-1 verify2 p-1 w-65 w-md-25"
              value={isMobile}
              onChange={handleMobileChange}
              onBlur={() => saveContactIdentity('mobile')} // 👈 trigger save
              required
              style={{
                border: `1px solid ${isMobileError ? "red" : "#236723"}`,
                paddingLeft: "10px",
              }}
            />


            <select
              className="w-70 w-md-25 mt-2  ms-md-2" // Makes the select full width on small screens
              aria-label="Default select example"
              value={isRelation}
              style={{
                border: "none",
                borderBottom: "1px solid green",
                paddingLeft: "1rem",
                minWidth: "7ch",
              }}
              onChange={handleRelationChange} // Use the new handler
            >
              <option value="" disabled>
                Select
              </option>
              <option value="SP">Spouse</option>
              <option value="SE">Self</option>
              <option value="DC">Dependent Children</option>
              <option value="DP">Dependent Parent</option>
            </select>
            {relationError && (
              <div style={{ color: "red" }}>{relationError}</div>
            )}
          </div>
        </div>

        <div className="row mt-4 ">
          <div className="col-12 col-md d-flex flex-column flex-md-row gap-2 align-items-start">
            <p className="reward24  mb-2 mb-md-0 ">and email address: </p>
            <input
              type="email"
              placeholder="Email"
              className="my-2 verify2 my-md-0 rounded-1 py-1 w-70 w-md-50"
              value={isEmail}
              required
              onChange={handleEmailChange}
              onBlur={() => saveContactIdentity('email')} // Optional: Auto-save on blur
              style={{
                border: `1px solid ${isEmailError ? "red" : "#236723"}`,
                paddingLeft: "10px",
              }}
            />


            <select
              className="  w-70 w-md-25  mt-2  ms-md-2" // Makes the select full width on small screens
              aria-label="Default select example"
              value={isRelation2}
              style={{
                border: "none",
                borderBottom: "1px solid green",
                paddingLeft: "1rem",
                minWidth: "7ch",
              }}
              onChange={handleRelation2Change} // Use the new handler
            >
              <option value="" disabled>
                Select
              </option>
              <option value="SP">Spouse</option>
              <option value="SE">Self</option>
              <option value="DC">Dependent Children</option>
              <option value="DP">Dependent Parent</option>
            </select>
            {relation2Error && (
              <div style={{ color: "red" }}>{relation2Error}</div>
            )}
          </div>
        </div>
        {/* <div className="reward24 d-flex align-items-center"> */}


        {(iAmOption === "21" || iAmOption === "24") && (
          <Form className="mt-4">
            <div
              className="
        d-flex flex-column gap-3
        d-lg-flex flex-lg-row align-items-lg-center gap-lg-3
      "
            >
              {/* QUESTION */}
              <Form.Label className="reward24 text-nowrap mb-0">
                Do you have TIN:
              </Form.Label>

              {/* YES / NO */}
              <div className="d-flex gap-3">
                <Form.Check
                  type="radio"
                  label="Yes"
                  checked={hasTin === "yes"}
                  onChange={() => {
                    setHasTin("yes");
                    setIdType("");
                    setTinError("");
                    tinSavedRef.current = false;
                  }}
                  onBlur={handleTinBlur}
                />

                <Form.Check
                  type="radio"
                  label="No"
                  checked={hasTin === "no"}
                  onChange={() => {
                    setHasTin("no");
                    setTinNumber("");
                    setTinError("");
                    tinSavedRef.current = false;
                  }}
                  onBlur={handleTinBlur}
                />
              </div>

              {/* TIN NUMBER */}
              {hasTin === "yes" && (
                <Form.Control
                  type="text"
                  placeholder="TIN Number"
                  className="w-100 w-lg-auto"
                  style={{ maxWidth: "180px" }}
                  value={tinNumber}
                  onChange={(e) => {
                    setTinNumber(
                      e.target.value.toUpperCase().replace(/[^A-Z0-9-]/g, "")
                    );
                    setTinError("");
                    tinSavedRef.current = false;
                  }}
                  onBlur={handleTinBlur}
                  isInvalid={!!tinError}
                />
              )}

              {/* ID TYPE */}
              {hasTin === "no" && (
                <Form.Select
                  className="w-100 w-lg-auto"
                  style={{ maxWidth: "260px" }}
                  value={idType}
                  onChange={(e) => {
                    setIdType(e.target.value);
                    setTinError("");
                    tinSavedRef.current = false;
                  }}
                  onBlur={handleTinBlur}
                  isInvalid={!!tinError}
                >
                  <option value="">Select ID Type</option>
                  <option value="J">Student Visa</option>
                  <option value="K">Diplomat Visa</option>
                  <option value="N">Global Entity Identification Number</option>
                  <option value="Q">US GIIN</option>
                  <option value="F">Dependent Visa</option>
                  <option value="I">Social Security ID Card</option>
                  <option value="M">Mariner / Sea farer</option>
                  <option value="S">Sportsperson / Professional</option>
                  <option value="T">TIN</option>
                  <option value="D">ID Card</option>
                </Form.Select>
              )}

              {/* CITY */}
              <Form.Control
                type="text"
                placeholder="City"
                className="w-100 w-lg-auto"
                style={{ maxWidth: "160px" }}
                value={isCity}
                onChange={(e) => {
                  setIsCity(e.target.value);
                  setCityError("");
                  tinSavedRef.current = false;
                }}
                onBlur={handleTinBlur}
                isInvalid={!!cityError}
              />

              {/* COUNTRY */}
              <div style={{ minWidth: "220px" }}>
                <Select
                  options={countryOptions}
                  placeholder="Country"
                  isSearchable
                  value={isCountry}
                  styles={{
                    control: (base) => ({
                      ...base,
                      backgroundColor: isDarkMode ? "#1f1f1f" : "#ffffff",
                    }),
                    singleValue: (base) => ({
                      ...base,
                      color: isDarkMode ? "#ffffff" : "#212529",
                    }),
                    option: (base, state) => ({
                      ...base,
                      backgroundColor: state.isFocused
                        ? isDarkMode ? "#333" : "#f1f1f1"
                        : isDarkMode ? "#1f1f1f" : "#ffffff",
                      color: isDarkMode ? "#ffffff" : "#212529",
                    }),
                  }}

                  onChange={(val) => {
                    console.log('isCountry', isCountry);

                    setIsCountry(val);
                    setCountryError("");
                    tinSavedRef.current = false;
                  }}
                  onBlur={handleTinBlur}
                  menuPortalTarget={document.body}
                // styles={{
                //   menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                //   control: (base) => ({
                //     ...base,
                //     borderColor: countryError ? "red" : base.borderColor,
                //   }),
                // }}
                />
              </div>
            </div>

            {/* ERRORS */}
            {(tinError || cityError || countryError) && (
              <div className="text-danger mt-2">
                {tinError || cityError || countryError}
              </div>
            )}
          </Form>
        )}






        {/* </div> */}
        {/* verify button */}
        {isKycDone !== 'yes' &&
          // showWebcamMic&&
          <div className="row">
            <div className="col mt-4 d-flex align-content-center gap-2 ">
              <input
                type="checkbox"
                checked={isConfirm}
                onChange={(e) => handleConfirm(e)}
              />
              <p className=" " style={{ lineHeight: '20px' }}>I confirm that this mobile number is linked to the client's Aadhaar. {' '}
                <span
                  className="clrgreen fw-medium curson-pointer"
                  style={{ cursor: "pointer" }}
                  onClick={handleVerifyModal}
                >
                  Click here to verify on UIDAI website
                </span>
              </p>
            </div>
          </div>
        }
        <div className="row my-md-4 p-3">
          <div className="col-12 text-end  mt-4" >
            <a onClick={handleBack} style={{ cursor: 'pointer' }}>
              <img
                className="arrow_next1"
                src="assets/images/left-arrowpng.png"
                alt=""
              />
            </a>
            <a className="ms-1" onClick={handleNext} style={{ cursor: 'pointer' }}>
              <img
                className="arrow_next"
                src="assets/images/right-arrow.svg"
                alt=""
              />
            </a>
          </div>
        </div>
      </div>

      <CaptchaVerification
        show={modalShow}
        onHide={() => setModalShow(false)}
        onSave={handleSave}
        roomId={roomId}
        panNumber={panNumber}
        iAmOption={iAmOption}
        kycStatus={kycStatus}
        fatcaStatus={fatcaStatus}
        mobileNumbe={mobileNumber}
        emailAddress={emailAddress}
        aadhaarConfirmed={aadhaarConfirmed}
        isRelation={isRelation}
        isRelation2={isRelation2}
        clientEmail={clientEmail}
      />
      <VerifyModal
        show={modalShowVerify}
        onHide={() => setModalShowVerify(false)}
        //  onSave={handleAddressType}
        roomId={roomId}
      />
      <AppointmentScheduleModal
        show={showModal}
        onHide={() => setShowModal(false)}
        roomId={roomId}
        clientData={clientData}
      />
    </>
  );
};
